// @ts-expect-error -- Suppresses TS and ESLint errors.
type _ = Types.Scalars;
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import type * as Types from '../util-types.js';

export type AdminMeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AdminMeQuery = {
  adminMe?: {
    __typename: 'AdminUser';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    displayName: string;
    superAdmin: boolean;
    platformAdminUsers: Array<{
      __typename: 'PlatformAdminUser';
      id: string;
      owner: boolean;
      platform: {
        __typename: 'Platform';
        id: string;
        handle: string;
        name: string;
        featureFlags: Array<string>;
        sitesSubscriptionStatus?: Types.SubscriptionStatus | null;
        sitesCount: number;
        mainSiteId?: string | null;
      };
      permissions: Array<{ __typename: 'Permission'; id: string; object: string; action: string }>;
    }>;
  } | null;
};

export const AdminMeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminMe' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminMe' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AdminMe' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminMe' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AdminUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'superAdmin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platformAdminUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'platform' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'handle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sitesSubscriptionStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sitesCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mainSiteId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'object' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'owner' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminMeQuery, AdminMeQueryVariables>;
